import { render } from "./SVGColorItem.vue?vue&type=template&id=17344baa"
import script from "./SVGColorItem.vue?vue&type=script&lang=js"
export * from "./SVGColorItem.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__